import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

function Heading({ title }: { title: string }) {
  const { t } = useTranslation('products')

  const {
    query: { q },
  } = useRouter()

  return (
    <div className="flex items-center justify-between">
      <h2 className="text-xl font-medium md:text-2xl">
        {t(title, { search: String(q) })}
      </h2>
    </div>
  )
}

export default Heading
